import EditAlert from "@ext/markdown/elements/alert/edit/components/EditAlert";
import alertSchema from "@ext/markdown/elements/alert/edit/model/alertSchema";
import getExtensionOptions from "@ext/markdown/logic/getExtensionOptions";
import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

const Alert = Node.create({
	...getExtensionOptions({ schema: alertSchema, name: "alert" }),

	parseHTML() {
		return [{ tag: "alert-react-component" }];
	},

	renderHTML({ HTMLAttributes }) {
		return ["alert-react-component", mergeAttributes(HTMLAttributes), 0];
	},

	addNodeView() {
		return ReactNodeViewRenderer(EditAlert);
	},
});

export default Alert;
